module.exports = __webpack_public_path__ + "img/slideshow_1.3b4f616f.jpg";